import { MB_ANALYTICS_DATA_FEATURE } from './state'
import { NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'
import { reducer } from './reducers/cart-meta-data.reducer'

@NgModule({
  imports: [
    StoreModule.forFeature(MB_ANALYTICS_DATA_FEATURE, reducer),
  ],
})
export class MbAnalyticsStoreModule {
}
